import PeopleIcon from '@mui/icons-material/People'
import { Badge, Box, List, ListItem, ListItemButton, ListItemIcon, Typography, useTheme } from '@mui/material'
import ConnectedUsers from '../../../context/Websocket/ConnectedUsers'
import { useWebsocketContext } from '../../../context/Websocket/WebsocketProvider'
import { QuickChatButton } from '../../QuickChat'

const ConnectedUsersNav = ({ isConnectedUsersOpen, handleOpenConnectedUsers, handleCloseConnectedUsers }) => {
  const theme = useTheme()
  const { connectedUsers, ws } = useWebsocketContext()

  // Show at least 1 if WebSocket is connected (current user is always connected)
  const connectedCount =
    Array.isArray(connectedUsers) && connectedUsers.length > 0
      ? connectedUsers.length
      : ws && ws.readyState === WebSocket.OPEN
      ? 1
      : 0
  // Because you only have a single item, you *could* skip the .map entirely,
  // but we'll show the structure in case you add more items later.
  const navItems = [{ label: 'Connected Users' }]

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 0.5 }}>
        {/* Quick Chat Button */}
        <QuickChatButton size="medium" />

        {/* Connected Users Button */}
        <List
          disablePadding
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            m: 0,
          }}
        >
          {navItems.map(item => (
            <ListItem
              key={item.label}
              disablePadding
              sx={{
                display: 'inline-flex',
                width: 'auto',
              }}
            >
              <ListItemButton
                disableGutters
                onClick={handleOpenConnectedUsers}
                sx={{
                  minWidth: 50,
                  minHeight: 50,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  transition: 'transform 0.2s ease-in-out',
                  '& .MuiSvgIcon-root': {
                    color: theme.palette.text.primary,
                    transition: 'color 0.2s ease-in-out',
                  },
                  '&:hover': {
                    backgroundColor: 'transparent',
                    transform: 'scale(1.2)',
                    '& .MuiSvgIcon-root': {
                      color: 'text.highlight',
                    },
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    justifyContent: 'center',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Badge
                    badgeContent={
                      <Typography
                        sx={{
                          fontSize: 12,
                          color: 'rgba(63, 195, 128, 1)',
                          fontWeight: 'bold',
                        }}
                      >
                        {connectedCount}
                      </Typography>
                    }
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                  >
                    <PeopleIcon
                      sx={{
                        height: 22,
                        width: 22,
                      }}
                    />
                  </Badge>
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>

      {/* Quick Chat Drawer */}

      {isConnectedUsersOpen && (
        <ConnectedUsers
          isConnectedUsersOpen={isConnectedUsersOpen}
          handleCloseConnectedUsers={handleCloseConnectedUsers}
        />
      )}
    </>
  )
}

export default ConnectedUsersNav
